var map = {
	"./CausalChain.png": "26da",
	"./FunctionalCropping.png": "32d8",
	"./StandardSolution.png": "83b7",
	"./deepSeek.png": "6f15",
	"./fos.png": "4488",
	"./functional.png": "c09d",
	"./inventive.png": "44f9",
	"./inventive1.png": "f2b9",
	"./patent.png": "c581",
	"./resolvingConflicts.png": "54b1",
	"./science.png": "73f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1ee9";